import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiCall } from '../utils/api';

function ViewRunbook() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [runbook, setRunbook] = useState(null);

  useEffect(() => {
    const fetchRunbookData = async () => {
      try {
        const data = await apiCall(`/runbooks/${id}`);
        setRunbook(data);
      } catch (error) {
        console.error('Error fetching runbook:', error);
        setRunbook(null);
      }
    };

    fetchRunbookData();
  }, [id]);

  if (!runbook) {
    return <div className="container mt-4">Loading runbook details or runbook not found...</div>;
  }

  return (
    <div className="container mt-4">
      <h1>View Runbook</h1>

      <form>
        <label>Runbook ID:</label>
        <input
          type="text"
          name="runbook_id"
          value={runbook['Runbook ID']}
          readOnly
          className="form-control"
          style={{ backgroundColor: '#d6d6d6', color: '#333' }}
        />

        <label>Runbook Title:</label>
        <input
          type="text"
          name="runbook_title"
          value={runbook['Runbook Title']}
          readOnly
          className="form-control"
          style={{ backgroundColor: '#d6d6d6', color: '#333' }}
        />

        <label>Tribe:</label>
        <input
          type="text"
          name="tribe"
          value={runbook.Tribe}
          readOnly
          className="form-control"
          style={{ backgroundColor: '#d6d6d6', color: '#333' }}
        />

        <label>Solution:</label>
        <input
          type="text"
          name="solution"
          value={runbook.Solution}
          readOnly
          className="form-control"
          style={{ backgroundColor: '#d6d6d6', color: '#333' }}
        />

        <label>Tags:</label>
        <input
          type="text"
          name="tags"
          value={runbook.Tags}
          readOnly
          className="form-control"
          style={{ backgroundColor: '#d6d6d6', color: '#333' }}
        />

        {runbook.Modules && runbook.Modules.length > 0 && (
          <>
            <label>Existing Modules:</label>
            <table className="table table-bordered">
              <thead className="table-dark">
                <tr>
                  <th>Module ID</th>
                  <th>Module Description</th>
                </tr>
              </thead>
              <tbody>
                {runbook.Modules.map((moduleItem) => (
                  <tr key={moduleItem['Module ID']}>
                    <td>{moduleItem['Module ID']}</td>
                    <td>{moduleItem['Module Description']}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        <label>Modified By:</label>
        <input
          type="text"
          name="modified_by"
          value={runbook.ModifiedBy}
          readOnly
          className="form-control"
          style={{ backgroundColor: '#d6d6d6', color: '#333' }}
        />
      </form>

      <div className="mt-3 d-flex justify-content-end gap-2">
        <button type="button" className="btn btn-secondary" onClick={() => navigate('/runbook_list')}>Back</button>
      </div>
    </div>
  );
}

export default ViewRunbook;